// extracted by mini-css-extract-plugin
export default {"verticalStack":"VerticalStack_verticalStack__KEmM4","bottomPadding":"VerticalStack_bottomPadding__AmYXF"};